import React, { useEffect, useState } from 'react';
import { secureFetch } from "../utils/secureFetch";
import { useNavigate } from "react-router-dom";

const API_BASE = process.env.REACT_APP_API_BASE;

export default function PlayerDashboard() {
  const [balance, setBalance] = useState(0);
  const [transactions, setTransactions] = useState([]);
  const [drinks, setDrinks] = useState([]);
  const [profile, setProfile] = useState(null);
  const email = localStorage.getItem("beercard_logged_in_email");
  const navigate = useNavigate();

  useEffect(() => {
    if (!email) {
      alert("❌ You must be logged in.");
      window.location.href = "/";
      return;
    }
    fetchData();
  }, [email, navigate]);

  const fetchData = async () => {
    try {
      const profileRes = await secureFetch(`${API_BASE}/user`);

      if (profileRes?.status === "approved") {
        setProfile(profileRes);

        const teamId = profileRes.teamId;
        const clubId = profileRes.clubId;

        if (!teamId || !clubId) {
          alert("Your account is missing team setup details. Please ask your team admin to check your player setup.");
        return;
        }

        localStorage.setItem("beercard_teamId", teamId);
        localStorage.setItem("beercard_clubId", clubId);

        const [balanceRes, drinksRes, txRes] = await Promise.all([
          secureFetch(`${API_BASE}/balance`),
          secureFetch(`${API_BASE}/drinks?teamId=${teamId}&clubId=${clubId}`),
          secureFetch(`${API_BASE}/transactions`)
        ]);

        setBalance(balanceRes?.balance ?? 0);
        setDrinks(drinksRes || []);
        setTransactions(txRes || []);
      } else {
        alert("Awaiting approval.");
        navigate("/login");
      }
    } catch (err) {
      console.error(err);
    }
  };

  const handleRedeem = async (drinkName) => {
    try {
      await secureFetch(`${API_BASE}/drinks/redeem`, {
        method: "POST",
        body: JSON.stringify({
          email,
          drinkName,
          teamId: profile.teamId,
          clubId: profile.clubId
        })
      });

      alert(`✅ Redeemed ${drinkName}`);
      fetchData();
    } catch (err) {
      alert("❌ Redeem failed");
    }
  };

  return (
    <div className="min-h-screen w-full bg-[var(--tk-navy)] text-white">
      <div className="w-full max-w-4xl px-3 sm:px-6 py-6 mx-auto">

        {!profile ? (
          <div>Loading...</div>
        ) : (
          <>
            {/* HEADER */}
            <h1 className="text-xl font-bold mb-4">
              Welcome, {profile.firstName}
            </h1>

            {/* BALANCE CARD */}
            <div className="bg-white text-slate-900 rounded-xl shadow-md p-4 mb-4">
              <div className="text-sm text-gray-500">Your Balance</div>
              <div className="text-2xl font-bold">
                ${balance.toFixed(2)}
              </div>
            </div>

            {/* TOP UP */}
            <button
              onClick={() => navigate("/topup")}
              className="w-full bg-green-600 text-white py-3 rounded-xl mb-4"
            >
              Top Up Balance
            </button>

            {/* DRINKS */}
            <h2 className="text-md font-semibold mb-3">Available Drinks</h2>

            <div className="grid gap-3 mb-6">
              {drinks.map((drink) => (
                <div
                  key={drink.name}
                  className="bg-white text-slate-900 rounded-xl shadow-md p-4"
                >
                  <div className="flex justify-between items-center">

                    <div>
                      <div className="text-lg font-bold">{drink.name}</div>
                      <div className="text-sm text-gray-500">
                        ${Number(drink.price).toFixed(2)} • {drink.stock} left
                      </div>
                    </div>

                    <button
                      onClick={() => handleRedeem(drink.name)}
                      disabled={drink.stock <= 0 || balance < drink.price}
                      className={`px-4 py-2 rounded-lg text-white ${
                        drink.stock <= 0 || balance < drink.price
                          ? "bg-gray-400"
                          : "bg-blue-600 hover:bg-blue-700"
                      }`}
                    >
                      Redeem
                    </button>

                  </div>
                </div>
              ))}
            </div>

            {/* RECENT ACTIVITY (unchanged) */}
            <h2 className="text-md font-semibold mt-6 mb-3">Recent Activity</h2>

            <div className="flex flex-col gap-3">
              {transactions.slice(0, 10).map((tx, i) => (
                <div key={i} className="bg-slate-800 p-3 rounded">
                  <div className="text-sm">{tx.description}</div>
                  <div className="text-xs text-gray-400">
                    {new Date(tx.date).toLocaleString()}
                  </div>
                </div>
              ))}
            </div>

          </>
        )}
      </div>
    </div>
  );
}